import React, { useEffect } from 'react';
import { motion, useScroll } from "framer-motion"
import Menu from "./components/Menu";
import Hero from "./components/Hero";
import Header from "./components/Header";
import AboutMe from "./components/AboutMe";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import ErrorBoundary from "./components/ErrorBoundary";
import MathShapes from "./components/shapes/MathShapes";
import LeadsDashboard from "./components/LeadsDashboard";
import SunilAnandPage from "./components/SunilAnandPage";
import { gsap } from "gsap";
import "./App.css";

function App() {
  const isLeadsPage = window.location.pathname === "/saleads";
  const isSunilAnandPage = window.location.pathname === "/sunil-anand";
  const { scrollYProgress } = useScroll();

  useEffect(() => {
    const handleMousemove = (event) => {
      // Get the mouse coordinates relative to the window
      const mouseX = event.clientX;
      const mouseY = event.clientY;
  
      // Get the current scroll position
      const scrollX = window.scrollX;
      const scrollY = window.scrollY;
  
      // Adjust the mouse coordinates based on the scroll position
      const adjustedX = mouseX + scrollX;
      const adjustedY = mouseY + scrollY;
      
  
  
      gsap.to(".hover_effect_shape", {
        x: adjustedX,
        y: adjustedY,
        stagger: 0.1,
      });
    };
    window.addEventListener("mousemove", handleMousemove);








    
    return () => {
      window.removeEventListener("mousemove", handleMousemove);
    };
  }, []);

  return (
    <ErrorBoundary>
      {isLeadsPage ? (
        <LeadsDashboard />
      ) : isSunilAnandPage ? (
        <SunilAnandPage />
      ) : (
      <div className="App">
        <motion.div
          className="progress-bar"
          style={{ scaleX: scrollYProgress }}
        />  
        <div className='hover_effect'>
          <div className="hover_effect_cursor"></div>
          <div className="hover_effect_shapes"></div>
          <div className="hover_effect_shape hover_effect_shape-1"></div>
          <div className="hover_effect_shape hover_effect_shape-2"></div>
          <div className="hover_effect_shape hover_effect_shape-3"></div>
        </div>
        <div className="all-sections-content">
          
          <Menu />
          <Hero />
          <main>
            <section className="parallax section" id="header" data-speed="0.9">
              <Header />
            </section>
            
            <section className="parallax section yellow" id="projects" data-speed="0.7">
              <Projects />
            </section>
            <section className="parallax section red" id="skills" data-speed="0.6">
              <MathShapes />
              <Skills />
            </section>
            <section className="parallax section black" id="about-me" data-speed="0.5">
              <AboutMe />
            </section>
            <section className="parallax section yellow last-section" id="contact" data-speed="0.4">
              <Contact />
            </section>
          </main>
          
        </div>
      </div>
      )}
    </ErrorBoundary>
  );
}

export default App;
